import Vue from "vue"
import VueRouter from "vue-router"

// 申込画面
import routesFirstOrder from "./routes.firstOrder"

// ログイン画面
import Login from "@/pages/Login";

// マスタパスワードログイン画面
import MasterLogin from "@/pages/MasterLogin";

// パスワード再設定
import routesResetPassword from "./routes.resetPassword"

// アカウントがないユーザ
import routesCreateAccount from "./routes.createAccount"

// サポートサイト利用時の画面
import routerSupportSite from "./routes.supportSite"

// 契約内容の画面
import routerContract from "./routes.contract"

// NEO契約追加時の画面
import routerContractNeoOrder from "./routes.contractNeoOrder"

// Chat契約追加時の画面
import routerContractChatOrder from "./routes.contractChatOrder"

// 各種製品マニュアル
import routesProductManuals from './routes.productManuals'

// エラー画面
import routerErrorPage from "./routes.errorPage"

// システムエラー
import SystemError from "@/pages/SystemError";

Vue.use(VueRouter)

let routes = [
  {
    // ログイン画面
    path: "/",
    name: "Login",
    component: Login,
    meta: {
      isUser: true,
      title: 'ログイン - desknet\'s NEO | ChatLuck クラウド版サポートサイト',
      description: 'ログインはこちらから。 - desknet\'s NEO・ChatLuck（クラウド版）のサポートサイトです。当サイトでは、お客様情報・ご契約数・オプションサービス・お支払い方法のご確認・ご変更が可能です。',
    }
  },
  {
    // マスタパスワードログイン画面
    path: "/master_login",
    name: "MasterLogin",
    component: MasterLogin,
    meta: {
      isUser: true
    }
  },
  {
    // システムエラー(申し込み番号が無し且つログイン不要な画面用)
    path: "/system_error",
    name: "SystemError",
    component: SystemError,
    props: true
  },
  // 申込画面
  {...routesFirstOrder},
  // パスワード再設定
  ...routesResetPassword.slice(),
  // アカウントがないユーザ
  ...routesCreateAccount.slice(),
  // サポートサイト利用時
  ...routerSupportSite.slice(),
  // 契約内容
  {...routerContract},
  // NEO契約追加時
  {...routerContractNeoOrder},
  // Chat契約追加時
  {...routerContractChatOrder},
  // 各種製品マニュアル
  ...routesProductManuals.slice(),
  // エラー画面
  ...routerErrorPage.slice(),
]

export const router = new VueRouter({
  mode: "history",
  base: process.env.BASE_URL,
  routes,
  scrollBehavior (to) {
    // アンカーが設定されている場合
    if (to.hash) {
      // アンカーへスクロールする
      return new Promise((resolve) => {
        setTimeout(() => {
          resolve({ selector: to.hash });
        }, 100);
      });
    }
    else {
      // 画面遷移時にスクロールTOPに戻る
      return { x: 0, y: 0 }
    }
  }
})

/**
 * ナビゲーションガード：遷移前
 */
router.beforeEach((to, from, next) => {
  // 初期化
  // タイトル
  window.document.title = 'desknet\'s NEO | ChatLuck クラウド版サポートサイト'
  // description
  window.document.querySelector('meta[name=\'description\']').content = 'desknet\'s NEO・ChatLuck（クラウド版）のサポートサイトです。当サイトでは、お客様情報・ご契約数・オプションサービス・お支払い方法のご確認・ご変更が可能です。'
  // canonical
  const canonical = window.document.querySelector('link[rel=\'canonical\']')
  if (canonical !== null) {
    canonical.remove()
  }
  // noindex
  const noindex = window.document.querySelector('meta[content=\'noindex\']')
  if (noindex !== null) {
    noindex.remove()
  }

  // ログイン前の画面の場合
  if ('title' in to.meta) {
    // タイトルを設定する
    window.document.title = to.meta.title
  }

  // 検索に引っかかってほしい画面の場合
  if ('description' in to.meta) {
    // canonicalを設定する
    const link = window.document.createElement('link')
    link.rel = 'canonical'
    link.href = window.location.origin + to.path
    window.document.head.appendChild(link)

    // descriptionを設定する
    window.document.querySelector('meta[name=\'description\']').content = to.meta.description
  }

  // ログイン前のエラー画面の場合
  if ('noindex' in to.meta) {
    // noindexを設定する
    const meta = document.createElement('meta')
    meta.name = 'robots'
    meta.content = 'noindex'
    window.document.head.appendChild(meta)
  }

  // 画面遷移する
  next()
})

export default router
